import '../SubAdmin/SubAdmin.css'
import { useEffect, useState } from "react";
import { Avatar, Grid, Card, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import axios from "axios";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDLoading from "components/MDLoading/MDLoading";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// ICONS
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

function SubAdmins() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const auth = localStorage.getItem("authToken");
    const user_id = localStorage.getItem("user_id");
    const [loading, setLoading] = useState(false);

    const [deleteLoading, setDeleteLoading] = useState(false);

    const [allUsers, setAllUsers] = useState([]);
    const [allUsersRowData, setAllUsersRowData] = useState([]);
    const [allAreas, setAllAreas] = useState([]);

    // Edit
    const [openDialog, setOpenDialog] = useState(false);
    const [editLoading, setEditLoading] = useState(false);
    const [dialogEditData, setDialogEditData] = useState({ user_id: '', name: '', area_id: '' });

    useEffect(() => {
        fetchAllSubAdmins();
        fetchAllAreas();
    }, [])

    const fetchAllSubAdmins = async () => {
        setLoading(true);
        await axios.post(`${process.env.REACT_APP_BASEURL}/admin/users/all-subAdmins`, { user_id }, {
            headers: { Authorization: `Bearer ${auth}` }
        })
            .then(res => {
                if (!res.data?.success) return enqueueSnackbar('Error Fetching Sub Admins !!!', { variant: 'error' })

                // const uniqueArray = Array.from(res.data.users?.reduce((map, obj) => map.set(obj.area_id, obj), new Map()).values());

                // const reducedUniqueArr = [];
                // uniqueArray?.forEach(u => reducedUniqueArr.push({ area_id: u?.area_id, area_name: u?.area_name }))

                // setAllAreas(reducedUniqueArr);

                createTableRowData(res.data.users);
                setAllUsers(res.data.users);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
                enqueueSnackbar('Error Fetching Areas !!!', { variant: 'error' })
            })
    }

    const fetchAllAreas = async () => {
        await axios.post(`${process.env.REACT_APP_BASEURL}/admin/areas/all`, { user_id }, {
            headers: { Authorization: `Bearer ${auth}` }
        })
            .then(res => {
                if (!res.data?.success) return enqueueSnackbar('Error Fetching Areas !!!', { variant: 'error' })

                setAllAreas(res.data.areas);
            })
            .catch(err => {
                console.log(err);
                enqueueSnackbar('Error Fetching Areas !!!', { variant: 'error' })
            })
    }

    const createTableRowData = (usersArr) => {
        const rowDataObjArr = [];

        usersArr?.forEach(u => {
            rowDataObjArr.push({
                area_name: (
                    <MDTypography display="block" variant="h6" fontWeight="medium" color="black" >
                        {u?.area_name}
                    </MDTypography>
                ),
                name: (
                    <MDBox display="flex" alignItems="center" lineHeight={1}>
                        <Avatar sx={{ height: 35, width: 35, backgroundColor: '#165ab3' }}>
                            {u?.name?.[0]}
                        </Avatar>
                        <MDTypography ml={1.5} display="block" fontWeight="medium" color="black" variant="h6" >
                            {u?.name}
                        </MDTypography>
                    </MDBox>
                ),
                email: (
                    <MDTypography display="block" variant="h6" fontWeight="normal" color="black" >
                        {u?.email}
                    </MDTypography>
                )
            })
        })

        setAllUsersRowData(rowDataObjArr);
    }

    const onDeleteClick = async (rowData) => {
        setDeleteLoading(true);

        const body = { user_id: allUsers[rowData?.row?.index]?.user_id }

        await axios.post(`${process.env.REACT_APP_BASEURL}/admin/users/delete`, body, {
            headers: { Authorization: `Bearer ${auth}` }
        })
            .then(res => {
                if (res.data?.success) {
                    enqueueSnackbar('Sub Admin Deleted Successfully !!!', { variant: 'success' })
                    const allUsersNew = [...allUsers];
                    allUsersNew.splice(rowData?.row?.index, 1);

                    const allUsersRowDataNew = [...allUsersRowData]
                    allUsersRowDataNew.splice(rowData?.row?.index, 1);

                    setAllUsers(allUsersNew);
                    setAllUsersRowData(allUsersRowDataNew);
                } else {
                    enqueueSnackbar('Error Deleting Sub Admin !!!', { variant: 'error' })
                }
                setDeleteLoading(false);
            })
            .catch(err => {
                console.log(err);
                setDeleteLoading(false);
                enqueueSnackbar('Error Deleting Sub Admin !!!', { variant: 'error' })
            })
    }

    const onEditClick = (rowData) => {
        const editUser = allUsers[rowData?.row?.index];

        setOpenDialog(true)
        setDialogEditData({ user_id: editUser?.user_id, name: editUser?.name, area_id: editUser?.area_id })
    }

    const onUpdate = async () => {
        if (Object.values(dialogEditData)?.includes('')) return enqueueSnackbar('Please Provide All The Details !!!', { variant: 'error' });

        setEditLoading(true);
        const body = { ...dialogEditData }

        await axios.put(`${process.env.REACT_APP_BASEURL}/admin/users/update-subadmin`, body, {
            headers: { Authorization: `Bearer ${auth}` }
        })
            .then(res => {
                if (res.data?.success) {
                    const updateIndex = allUsers?.findIndex(u => u.user_id === body.user_id)
                    if (updateIndex === -1) return enqueueSnackbar('Error Sub Admin Not Found !!!', { variant: 'error' })

                    const area_name = allAreas?.find(a => a.area_id === body.area_id)?.area_name
                    const allUsersArrTemp = [...allUsers];
                    const userObj = { ...allUsers[updateIndex], ...body, area_name }

                    allUsersArrTemp[updateIndex] = userObj;

                    setAllUsers(allUsersArrTemp);
                    createTableRowData(allUsersArrTemp);
                    enqueueSnackbar('Sub Admin Updated Successfully !!!', { variant: 'success' })
                } else {
                    enqueueSnackbar('Error Updating Admin !!!', { variant: 'error' })
                }

                setOpenDialog(false);
                setEditLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
                setEditLoading(false);
                enqueueSnackbar('Error Updating Sub Admin !!!', { variant: 'error' })
            })
    }

    const onCloseDialog = (e, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        setOpenDialog(false);
    };

    const columns = [
        { Header: "Area Name", accessor: "area_name", align: "left" },
        { Header: "Name", accessor: "name", width: '30%' },
        { Header: "Email", accessor: "email" },
        {
            Header: "Action",
            accessor: "action",
            align: "center",
            width: '10%',
            Cell: (row) => (
                <div>
                    <MDButton onClick={(e) => onDeleteClick(row)} variant="gradient" color="info" style={{ minWidth: 'unset', padding: '2px 12px' }} >
                        <DeleteIcon />
                    </MDButton >

                    <MDButton onClick={(e) => onEditClick(row)} variant="gradient" color="info" iconOnly sx={{ marginLeft: 1 }} >
                        <EditIcon />
                    </MDButton>
                </div >
            ),
        },
    ]
    return (
        <DashboardLayout>
            <DashboardNavbar hidebreadcrumbTitle />
            <MDBox pt={3} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info"
                                borderRadius="lg" coloredShadow="info"
                            >
                                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                                    <MDTypography variant="h6" color="white">
                                        Sub Admin Table
                                    </MDTypography>

                                    <MDBox className="admin_btnsHeaderCont">
                                        <MDButton onClick={() => navigate('/sub-admins/create')} variant="outlined" color="white">
                                            Create Sub Admin
                                        </MDButton>
                                    </MDBox>
                                </Grid>
                            </MDBox>
                            <MDBox pt={3}>
                                {loading ? (
                                    <CircularProgress sx={{ display: 'block', color: '#49a3f1', margin: '0 auto 20px' }} />
                                ) : (
                                    <DataTable
                                        table={{ columns, rows: allUsersRowData }}
                                        isSorted={false}
                                        entriesPerPage={false}
                                        showTotalEntries={false}
                                        noEndBorder
                                    />
                                )}
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>

            <MDLoading open={deleteLoading} />

            <Dialog fullWidth maxWidth='md' open={openDialog} onClose={onCloseDialog} >
                <DialogTitle sx={{ color: '#000' }} >Update Sub Admin</DialogTitle>
                <DialogContent>
                    <MDBox p={1}>
                        <MDInput type="text" label="Name" value={dialogEditData.name} name="name" margin="dense"
                            fullWidth onChange={(e) => setDialogEditData({ ...dialogEditData, name: e.target.value })}
                        />
                    </MDBox>

                    <MDBox p={1}  >
                        <TextField select label="Select Area" fullWidth className='subAdmin_select' margin='dense'
                            onChange={(e) => setDialogEditData({ ...dialogEditData, 'area_id': e.target.value })}
                            value={dialogEditData.area_id}
                        >
                            {allAreas?.map(a => (
                                <MenuItem key={a?.area_id} value={a?.area_id}>
                                    {a?.area_name}
                                </MenuItem>
                            ))}
                        </TextField>
                    </MDBox>

                </DialogContent>
                <DialogActions>
                    <MDButton variant="outlined" color="info" onClick={onCloseDialog} disabled={editLoading} >
                        Close
                    </MDButton>
                    <MDButton variant="gradient" onClick={onUpdate} style={{ backgroundColor: 'darkgreen', color: '#fff' }} disabled={editLoading} >
                        Update
                    </MDButton>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
}

export default SubAdmins;
